import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import fr from 'facet-rest';

const styles = () => ({
  root: {},
  infoBox: {
    textAlign: 'center',
  },
  text: {
    whiteSpace: 'pre-wrap',
  },
  title: {
    fontSize: 32,
  },
});

const Body = ({
  classes,
  onboardingStepResource,
}) => {
  return (
    <FDStack spacing={4} direction={'column'}>
      {onboardingStepResource.withRelationship(fr.relationships.lottie.name,
        (rel) => (
          <LottieLoadingLayout>
            <LottieRel relationship={rel} width={'250px'} height={'250px'} />
          </LottieLoadingLayout>
        ),
        () => null)}
      <Typography
        className={classes.title}
        variant={'h1'}
        color={'primary'}
        weight={'medium'}
        align={'center'}
        test={'wizard-step-title'}
      >
        {onboardingStepResource.attr('title')}
      </Typography>
      <FDBodyText value={onboardingStepResource.attr('primaryText')} color={'textDisabled'} align={'center'} />
    </FDStack>
  );
};

Body.defaultProps = {};

Body.propTypes = {
  classes: PropTypes.object.isRequired,
  onboardingStepResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Body);
